export { getDefaultRichTextElements } from './Localization';

import { Locale } from '../../types/localization';
import { getCorrectLocale } from '../localization';
import { generateLocalizationHeaders } from './generateLocalizationHeaders';
import { IntlShape, useIntl } from './useIntl';

export { generateLocalizationHeaders };
export { useIntl, type IntlShape } from './useIntl';
export { setCurrentLang, setMessages, setCustomTags } from './core';

export const CURRENCIES = {
  EURO: 'EUR',
  USD: 'USD',
};

export const LOCALE_CURRENCIES: { [key: string]: string } = {
  [Locale.GERMAN_GERMANY]: CURRENCIES.EURO,
  // TODO en_DE support
  [Locale.ENGLISH_GERMANY]: CURRENCIES.EURO,
  [Locale.ENGLISH_USA]: CURRENCIES.USD,
};

export const getCorrectLocaleString = (locale?: string): Locale => {
  const { lang, region } = getCorrectLocale(locale);

  return `${lang}-${region}` as Locale;
};

export const constructFormattedPriceResponse = (
  intl: IntlShape,
  value: number,
  maximumFractionDigits: number = 2,
  forceDigits?: boolean
) => {
  const parsedLocale = getCorrectLocaleString('de-DE');
  const currency = LOCALE_CURRENCIES[parsedLocale];

  return intl.formatNumber(value, {
    style: 'currency',
    currency,
    minimumFractionDigits: forceDigits ? maximumFractionDigits : 0,
    maximumFractionDigits,
  });
};

export const getFormattedPrice = (
  intl: IntlShape,
  value: number,
  maximumFractionDigits: number = 2,
  forceDigits?: boolean
) => {
  return constructFormattedPriceResponse(
    intl,
    value,
    maximumFractionDigits,
    forceDigits
  );
};

export const useFormattedPrice = (
  value: number,
  maximumFractionDigits: number = 2,
  forceDigits?: boolean
) => {
  const intl = useIntl();

  return constructFormattedPriceResponse(
    intl,
    value,
    maximumFractionDigits,
    forceDigits
  );
};
